<template>
    <div class="nk-content nk-content-fluid">
        <div class="container-xl wide-lg">
            <div class="nk-content-body">
                <div class="nk-block-head nk-block-head-sm">
                    <div class="nk-block-between g-3">
                        <div class="nk-block-head-content">
                            <h3 class="nk-block-title page-title">Upgrade Packages</h3>
                            <div class="nk-block-des text-soft">
                                <p>You have total {{rowCount}} Packages Request.</p>
                            </div>
                        </div><!-- .nk-block-head-content -->
                        <div class="nk-block-head-content">
                            <input v-model="search" type="text" class="form-control" placeholder="search...">

                        </div><!-- .nk-block-head-content -->
                    </div><!-- .nk-block-between -->
                </div><!-- .nk-block-head -->
                <div class="nk-block">
                    <div class="card card-bordered card-stretch">
                        <div class="card-inner-group">
                            <div class="card-inner p-0">
                                <table class="table table-tranx">
                                    <thead>
                                        <tr class="tb-tnx-head">
                                            <th class="tb-tnx-info">#</th>
                                            <th class="tb-tnx-info">
                                                Code
                                            </th>
                                            <th class="tb-tnx-info">
                                                User
                                            </th>
                                            <th class="tb-tnx-info">
                                                Date
                                            </th>
                                            <th class="tb-tnx-info">
                                                Current Package
                                            </th>
                                            <th class="tb-tnx-info">
                                                Upgrade Package
                                            </th>
                                            <th class="tb-tnx-info">
                                                Description
                                            </th>
                                            
                                            <th class="tb-tnx-info">
                                                Bank
                                            </th>
                                            <th class="tb-tnx-info">
                                                View
                                            </th>
                                            <th class="tb-tnx-action">
                                                <span>&nbsp;</span>
                                            </th>
                                        </tr><!-- tb-tnx-item -->
                                    </thead>
                                    <tbody>
                                        <tr v-for="(details, index) in userList" v-bind:key="details.id" class="tb-tnx-item">
                                            <td class="tb-tnx-info" v-if="currentPage === 1">
                                                {{index+1}}
                                            </td>
                                            <td class="tb-tnx-info" v-else>
                                                {{((currentPage*10)-10) +(index+1)}}
                                            </td>

                                            <td class="tb-tnx-info">
                                                {{details.code}}
                                            </td>
                                            <td class="tb-tnx-info">
                                                {{details.userName}}
                                            </td>
                                            <td class="tb-tnx-info">
                                                {{getDate(details.date)}}
                                            </td>
                                            <td class="tb-tnx-info">
                                                {{details.currentPackageName}} <br />
                                                ${{details.currentPackagePlanAmount}}
                                            </td>
                                            <td class="tb-tnx-info">
                                                {{details.packagePlanName}} <br />
                                                ${{details.packagePlanAmount}}
                                            </td>
                                            <td class="tb-tnx-info">
                                                {{details.description}}
                                            </td>
                                            
                                            <td class="tb-tnx-info">
                                                <a href="javascript:void(0)" v-on:click="ViewBank(details.screenShotImage)" class="btn btn-dim btn-sm btn-primary">View</a>
                                                {{details.bankName}}
                                            </td>
                                            <td class="tb-tnx-info">
                                                <span v-if="details.approvalStatus=='Draft'" class="badge badge-dot bg-primary">{{details.approvalStatus}}</span>
                                                <span v-if="details.approvalStatus=='Approved'" class="badge badge-dot bg-success">{{details.approvalStatus}}</span>
                                                <span v-if="details.approvalStatus=='Processing'" class="badge badge-dot bg-info">{{details.approvalStatus}}</span>
                                                <span v-if="details.approvalStatus=='Rejected'" class="badge badge-dot bg-danger">{{details.approvalStatus}}</span>
                                                <span v-if="details.approvalStatus=='Pending'" class="badge badge-dot bg-warning">{{details.approvalStatus}}</span>
                                                <span v-if="details.approvalStatus=='Expired'" class="badge badge-dot bg-light">{{details.approvalStatus}}</span>
                                            </td>
                                            <td class="tb-tnx-action">
                                                <div class="dropdown" v-if="details.approvalStatus!='Expired' && details.approvalStatus!='Rejected'">
                                                    <a class="text-soft dropdown-toggle btn btn-icon btn-trigger" data-bs-toggle="dropdown"><em class="icon ni ni-more-h"></em></a>
                                                    <div class="dropdown-menu dropdown-menu-end dropdown-menu-xs">
                                                        <ul class="link-list-plain">
                                                            <li v-if="details.approvalStatus=='Draft' || details.approvalStatus=='Processing'"><a v-on:click="ApprovalStatus(details.id, 'Approved')" href="javascript:void(0)">Approved</a></li>
                                                            <li v-if="details.approvalStatus=='Approved'"><a v-on:click="ApprovalStatus(details.id, 'Expired')" href="javascript:void(0)">Expired</a></li>
                                                            <li v-if="details.approvalStatus=='Draft'"><a v-on:click="ApprovalStatus(details.id, 'Processing')" href="javascript:void(0)">Processing</a></li>
                                                            <li v-if="details.approvalStatus=='Draft' || details.approvalStatus=='Processing'"><a v-on:click="ApprovalStatus(details.id, 'Rejected')" href="javascript:void(0)">Rejected</a></li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr><!-- tb-tnx-item -->
                                    </tbody>
                                </table>


                            </div><!-- .card-inner -->
                            <div class="card-inner">
                                <div class="nk-block-between-md g-3">
                                    <div class="g">
                                        <div class="pagination justify-content-center justify-content-md-start">
                                            <div class="overflow-auto" v-on:click="getPage()">
                                                <b-pagination pills size="md" v-model="currentPage"
                                                              :total-rows="rowCount"
                                                              :per-page="10"
                                                              first-text="First"
                                                              prev-text="Previous"
                                                              next-text="Next"
                                                              last-text="Last"></b-pagination>
                                            </div>
                                        </div><!-- .pagination -->
                                    </div>
                                    <div class="g">
                                        <div class="pagination-goto d-flex justify-content-center justify-content-md-start gx-3 text-capitalize">
                                            <span v-if="currentPage===1 && rowCount === 0"> Showing 0 to 0 of 0 entries</span>
                                            <span v-else-if="currentPage===1 && rowCount < 10"> Showing {{currentPage}} to {{rowCount}} of {{rowCount}} entries</span>
                                            <span v-else-if="currentPage===1 && rowCount >= 11  "> Showing {{currentPage}} to {{currentPage*10}} of {{rowCount}} entries</span>
                                            <span v-else-if="currentPage===1"> Showing {{currentPage}} to {{currentPage*10}} of {{rowCount}} entries</span>
                                            <span v-else-if="currentPage!==1 && currentPage!==pageCount"> Showing {{(currentPage*10)-9}} to {{currentPage*10}} of {{rowCount}} entries</span>
                                            <span v-else-if="currentPage === pageCount"> Showing {{(currentPage*10)-9}} to {{rowCount}} of {{rowCount}} entries</span>
                                        </div>
                                    </div><!-- .pagination-goto -->
                                </div><!-- .nk-block-between -->
                            </div><!-- .card-inner -->
                        </div><!-- .card-inner-group -->
                    </div><!-- .card -->
                </div><!-- .nk-block -->
            </div>
        </div>
        <deposit-detail-modal :path="path" :show="show" v-if="show" @close="show=false" />

        <loading :name="loading" :active.sync="loading"
                 :can-cancel="false"
                 :is-full-page="true"></loading>
    </div>

</template>
<script>
    import moment from "moment";
    import Loading from 'vue-loading-overlay';
    import "vue-loading-overlay/dist/vue-loading.css";

    export default {
        components: {
            Loading
        },
        name: 'PackagePriceList',
        data: function () {
            return {
                search: '',
                currentPage: 1,
                pageCount: '',
                rowCount: '',
                pageSize: '',
                isDesc: true,

                show: false,
                loading: false,
                userList: [],
                path: '',
            }
        },
        watch: {
            search: function (val) {
                this.GetData(val, 1);
            }
        },
        methods: {

            AddSignup: function () {
                this.$router.push('/AddBuyPackage')
            },
            ViewBank: function (path) {
                this.path = path;
                this.show = true;
            },

            getDate: function (date) {
                return moment(date).format('llll');
            },

            getPageSize: function (isDesc) {
                this.isDesc = isDesc;
                this.getPage();
            },

            getPage: function () {
                this.GetData(this.search, this.currentPage);
            },

            GetData: function (search, currentPage) {
                var root = this;
                var url = '/PackagePlan/UpgradeBuyPackageList?searchTerm=' + search + '&pageNumber=' + currentPage + '&isDesc=' + this.isDesc;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }

                root.$https.get(url, { headers: { "Authorization": `Bearer ${token}` } }).then(function (response) {
                    if (response.data != null) {
                        root.userList = response.data.results;
                        root.pageCount = response.data.pageCount;
                        root.rowCount = response.data.rowCount;
                    }
                }).catch(error => {
                    console.log(error)
                    root.$swal.fire({
                        icon: 'error',
                        type: 'error',
                        title: 'Error',
                        text: "Something Went Wrong",
                        showConfirmButton: false,
                        timer: 5000,
                        timerProgressBar: true,
                    });
                }).finally(() => root.loading = false);
            },


            ApprovalStatus: function (id, approval) {
                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                root.loading = true;
                root.$https.get('/PackagePlan/ApprovalStatusUpgradePackage?id=' + id + '&approval=' + approval, { headers: { "Authorization": `Bearer ${token}` } }).then(function (response) {
                    if (response.data.isSuccess) {
                        root.loading = false;
                        if (approval == 'Approved') {
                            root.$swal({
                                title: 'Approved!',
                                text: 'Status has been Changed successfully.',
                                type: 'success',
                                icon: 'success',
                                confirmButtonClass: "btn btn-success",
                                buttonsStyling: false
                            })
                        }
                        if (approval == 'Rejected') {
                            root.$swal({
                                title: 'Rejected!',
                                text: 'Status has been Changed successfully.',
                                type: 'success',
                                icon: 'success',
                                confirmButtonClass: "btn btn-success",
                                buttonsStyling: false
                            })
                        }
                        if (approval == 'Expired') {
                            root.$swal({
                                title: 'Expired!',
                                text: 'Status has been Changed successfully.',
                                type: 'success',
                                icon: 'success',
                                confirmButtonClass: "btn btn-success",
                                buttonsStyling: false
                            })
                        }
                        root.getPage();
                    }
                    else {
                        root.loading = false;
                        root.$swal({
                            title: 'Error!',
                            text: response.data.isAddUpdate,
                            type: 'error',
                            icon: 'error',
                            confirmButtonClass: "btn btn-danger",
                            buttonsStyling: false
                        });
                    }
                });
            },

        },
        created: function () {
        },
        mounted: function () {
            this.GetData(this.search, 1);
        },
    }
</script>